import React from 'react';

const HomeCodeContent = () => (
    <div className='home__code__content'>
        <span>
            <span className='code__color__purple'>function</span>
            &nbsp;
            {'initializeModelChunk<T>(chunk: '}
            <span className='code__color__orange'>ResolvedModelChunk</span>
            {'): T {'}
        </span>
        <span>
            &nbsp;&nbsp;&nbsp;
            <span className='code__color__blue'>const</span>
            &nbsp;
            {'value: T ='}
            &nbsp;
            <span className='code__color__green'>parseModel</span>
            {'(chunk.'}
            <span className='code__color__red'>_response</span>
            {', chunk.'}
            <span className='code__color__red'>_value</span>
            {');'}
        </span>
        <span>
            &nbsp;&nbsp;&nbsp;
            <span className='code__color__blue'>const</span>
            &nbsp;
            {'initializedChunk:'}
            &nbsp;
            <span className='code__color__orange'>InitializedChunk</span>
            {'<T> = (chunk: any);'}
        </span>
        <span>
            &nbsp;&nbsp;&nbsp;
            {'initializedChunk.'}
            <span className='code__color__red'>_status</span>
            &nbsp;
            {'= INITIALIZED;'}
        </span>
        <span>
            &nbsp;&nbsp;&nbsp;
            {'initializedChunk.'}
            <span className='code__color__red'>_value</span>
            &nbsp;
            {'= value;'}
        </span>
        <span>
            &nbsp;&nbsp;&nbsp;
            <span className='code__color__purple'>return</span>
            &nbsp;
            {'value;'}
        </span>
        <span>{'}'}</span>
    </div>
);

export default HomeCodeContent;
